export default "__VITE_ASSET__79e8e594__"